module.exports = __webpack_public_path__ + "static/media/ic_chevron_down.f587fbc8.svg";